<template>
  <div class="row col-md-12 m-0 p-0">
    <div class="col-md-8 col-12">
      <div class="tab-content mt-2">
        <div
          class="tab-pane"
          v-bind:class="{ active: step == 5 }"
          v-if="step == 5"
        >
          <error-message></error-message>

          <div class="row justify-content-center">
            <div class="col-sm-10 col-sm-offset-1">
              <h5 class="info-text">Policy Start Date</h5>
              <div class="form-group">
                <label
                  >Start date for your chosen coverage (dd/mm/yyyy)
                  <span class="required-field">*</span></label
                >
                <date-pick
                  :inputAttributes="{ placeholder: 'dd/mm/yyyy' }"
                  class="form-control col d-flex"
                  autofocus
                  required
                  v-model="fields.insurance_starts_at"
                  :style="showErrorMessage ? 'border:1px solid red' : ''"
                  :format="'DD/MM/YYYY'"
                  :isDateDisabled="disabledDates"
                ></date-pick>

                <!-- 
                <datepicker
                  style="cursor: default"
                  input-class="form-control pointer-cursor bd-faded"
                  name="start_date"
                  placeholder="Select Start Date of Coverage"
                  v-model="fields.insurance_starts_at"
                  :disabled-dates="disabledDates"
                  required
                /> -->
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-sm-10 col-sm-offset-1">
              <h5 class="info-text text-center">Business Address</h5>
              <div class="form-group">
                <label
                  >Business Address <span class="required-field">*</span></label
                >
                <input
                  type="text"
                  v-model="fields.business_address_line_1"
                  @focus="bindGoogleAddressPicker('business', $event)"
                  class="form-control"
                  placeholder="Your Business Address"
                  maxlength="190"
                />
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-4 col-sm-4 col-md-offset-1 col-sm-offset-1">
              <div class="form-group">
                <label>Suburb <span class="required-field">*</span></label>
                <input
                  type="text"
                  v-model="fields.business_address_suburb"
                  class="form-control"
                  placeholder="Suburb..."
                  maxlength="190"
                />
              </div>
            </div>

            <div class="col-sm-3 col-md-3">
              <div class="form-group">
                <label>State <span class="required-field">*</span></label>
                <select
                  class="form-control"
                  v-model="fields.business_address_state"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, key) in configs.states"
                    :value="key"
                    :key="key"
                  >
                    {{ state }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-3 col-md-3">
              <div class="form-group">
                <label>Postcode <span class="required-field">*</span></label>
                <input
                  type="text"
                  v-model="fields.business_address_postcode"
                  class="form-control"
                  placeholder="Postcode..."
                  maxlength="190"
                />
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-sm-12 row justify-content-center">
              <simple-google-map
                v-bind:lat="fields.business_address_lat"
                type="businessAddressMap"
                :address="fields.business_address_line_1"
                v-bind:lng="fields.business_address_lng"
              ></simple-google-map>
            </div>
          </div>

          <div class="row justify-content-center">
            <div
              class="col-sm-10 col-sm-offset-1 text-center"
              v-if="canSetPostalAddressSameAsBusinessAddress"
            >
              <div class="form-group">
                <label>
                  <input
                    type="checkbox"
                    v-model="postal_address_same_as_business_address"
                  />
                  Postal Address Same As Business Address
                </label>
              </div>
            </div>
          </div>

          <div
            class="row justify-content-center"
            v-show="!postal_address_same_as_business_address"
          >
            <div class="col-sm-10 col-sm-offset-1">
              <h5 class="info-text text-center">Postal Address</h5>
              <div class="form-group">
                <label
                  >Postal Address <span class="required-field">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  @focus="bindGoogleAddressPicker('postal', $event)"
                  v-model="fields.postal_address_line_1"
                  placeholder="Your Postal Address"
                  maxlength="190"
                />
              </div>
            </div>
          </div>

          <div
            class="row justify-content-center"
            v-show="!postal_address_same_as_business_address"
          >
            <div class="col-md-4 col-sm-4 col-md-offset-1 col-sm-offset-1">
              <div class="form-group">
                <label>Suburb <span class="required-field">*</span></label>
                <input
                  type="text"
                  v-model="fields.postal_address_suburb"
                  class="form-control"
                  placeholder="Suburb..."
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label>State <span class="required-field">*</span></label>
                <select
                  class="form-control"
                  name="postal_state"
                  v-model="fields.postal_address_state"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, key) in configs.states"
                    :value="key"
                    :key="key"
                  >
                    {{ state }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label>Postcode <span class="required-field">*</span></label>
                <input
                  type="text"
                  v-model="fields.postal_address_postcode"
                  class="form-control"
                  placeholder="Postcode..."
                  maxlength="190"
                />
              </div>
            </div>
          </div>

          <div
            class="row justify-content-center"
            v-show="!postal_address_same_as_business_address"
          >
            <div class="col-sm-12 row justify-content-center">
              <simple-google-map
                v-bind:lat="fields.postal_address_lat"
                type="postalAddressMap"
                :address="fields.postal_address_line_1"
                v-bind:lng="fields.postal_address_lng"
              ></simple-google-map>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xs-12 text-center">
              <h5 class="info-text">Payment Details</h5>
              <div class="form-group">
                <label class="text-dark m-r-25">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="credit_card"
                    v-model="fields.payment_type"
                  />
                  Pay using Credit Card
                </label>
                <label class="text-dark m-r-25">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="bank_transfer"
                    v-model="fields.payment_type"
                  />
                  Pay in 7 Days by Bpay
                </label>
                <label class="text-dark" v-if="eFundAvailable">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="efund"
                    v-model="fields.payment_type"
                  />
                  Pay By Month
                </label>
                <!-- <label class="text-dark">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="stripe"
                    v-model="fields.payment_type"
                  />
                  Pay By Apple Pay
                </label> -->
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-sm-12">
              <div v-if="fields.payment_type == 'stripe'">
                <stripe-payment-page :stripePk="this.stripePk" @STRIPE-PAYMENT="this.handleStripePayment()"></stripe-payment-page>
              </div>
              <div
                id="creditCardPaymentForm"
                v-if="fields.payment_type == 'credit_card'"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="push-50-t clearfix text-center">
                      <img
                        :src="creditCardUrl"
                        alt="Secured Payment Gateway"
                        data-toggle="tooltip"
                        title="Powered by Stripe"
                        data-placement="bottom"
                      />
                    </div>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-sm-10 col-sm-offset-1">
                    <div class="form-group">
                      <label
                        ><span>Cardholder Name</span>
                        <span class="required-field">*</span></label
                      >
                      <!-- .fs-exclude is to include it from fullstory tracking -->
                      <input
                        type="text"
                        class="form-control border-primary fs-exclude"
                        data-stripe="name"
                        placeholder="John Smith..."
                        autocomplete="off"
                        v-model="fields.card_name"
                      />
                    </div>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-sm-10 col-sm-offset-1">
                    <div class="form-group">
                      <label
                        ><span>Card Number</span>
                        <span class="required-field">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control border-primary fs-exclude"
                        placeholder="1234 5678 9123 4567..."
                        autocomplete="off"
                        v-model="fields.card_number"
                      />
                    </div>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-sm-10 col-sm-offset-1">
                    <label
                      >Expiration <span class="required-field">*</span></label
                    >
                    <div class="row">
                      <div class="col-sm-4 sm-m-b-10">
                        <select
                          class="form-control border-primary fs-exclude"
                          v-model="fields.card_exp_month"
                        >
                          <option value="">Select a month</option>
                          <option
                            v-for="month in 12"
                            :value="month"
                            :key="month"
                          >
                            {{ formatMonthNumber(month) }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-4 sm-m-b-10">
                        <select
                          class="form-control border-primary fs-exclude"
                          v-model="fields.card_exp_year"
                        >
                          <option value="">Select a year</option>
                          <option
                            v-for="(year, key) in configs.credit_card_years"
                            :value="key"
                            :key="key"
                          >
                            {{ year }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-4 sm-m-b-10">
                        <input
                          type="text"
                          id="cvc"
                          class="form-control border-primary fs-exclude"
                          placeholder="CVC"
                          data-stripe="cvc"
                          v-model="fields.card_cvc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div
              id="payIn7Days"
              v-if="fields.payment_type == 'bank_transfer'"
              class="row col-md-12 justify-content-center"
            >
              <div class="col-sm-10 col-sm-offset-1">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="alert alert-info alert-simple">
                      <p>
                        <b>
                          If you are choosing to pay by invoice in 7 days, we
                          will not be able to send your Certificate of Currency,
                          which is your proof you have insurance, until we
                          receive payment into our bank.
                        </b>
                      </p>
                      <p>
                        If you need to prove you are insured to someone for work
                        or to get on-site, the quickest way to get your
                        Certificate of Currency is by paying with a Credit Card
                        or Pay by the month.
                      </p>
                    </div>

                    <label
                      class="flex justify-content-center col-12 text-center"
                    >
                      <input type="checkbox" v-model="accepts" /> I understand
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row justify-content-center"
            v-if="fields.payment_type == 'efund' && eFundAvailable"
          >
            <div class="col-sm-10 col-sm-offset-1">
              <div
                class="alert alert-info alert-simple font-12"
                style="padding: 0"
              >
                <p style="padding: 10px 15px">
                  Monthly Payments
                  <span class="float-right">${{ monthlyPayment }} / month</span>
                </p>
              </div>
            </div>
          </div>

          <div
            class="row justify-content-center"
            v-if="fields.payment_type == 'efund' && eFundAvailable"
          >
            <div class="col-sm-10 col-sm-offset-1">
              <div class="form-group">
                <label>
                  <span>Please provide your ABN (Optional)</span>
                </label>
                <input
                  type="text"
                  class="form-control border-primary"
                  placeholder="XX XXX XXX XXX"
                  autocomplete="off"
                  name="abn"
                  v-model="fields.abn"
                  maxlength="190"
                  minlength="11"
                  @change="verifyABN()"
                />
                <p ref="abnErrorField" class="text-danger py-2"></p>
              </div>
            </div>
          </div>

          <div
            class="row justify-content-center mt-4"
            v-if="insuranceStartsDate"
          >
            <div class="col-sm-10 col-sm-offset-1">
              <div class="alert alert-warning">
                <p>
                  Please note:<br />
                  <strong
                    >The Public liability policy will be started from your
                    chosen date: {{ insuranceStartsDate }}</strong
                  ><br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="wizard-footer"
        style="padding-top: 20px"
        v-if="paymentPageType !== 'chat'"
      >
        <div class="clearfix"></div>
        <div class="pull-right">
          <button
            type="button"
            @click.prevent="confirmFormSubmission"
            class="btn btn-next btn-fill btn-success btn-wd"
            :disabled="disableButton"
          >
            Purchase Cover <i class="fa fa-check"></i>
          </button>
        </div>
        <div class="pull-left">
          <button
            type="button"
            class="btn btn-previous btn-default btn-wd"
            @click="previousClicked"
          >
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
        <div class="clearfix"></div>
      </div>

      <div
        class="wizard-footer d-flex justify-content-center"
        style="padding-top: 20px"
        v-if="paymentPageType === 'chat'"
      >
        <button
          type="button"
          @click.prevent="confirmFormSubmission"
          class="btn btn-next btn-fill btn-success btn-wd col-10"
          :disabled="disableButton"
        >
          Purchase Cover <i class="fa fa-check"></i>
        </button>
      </div>
    </div>

    <summary-endorsements
      :pendingOrder="pendingOrder"
      class="col-md-4 col-sm-6 col-12 mt-2"
    />
  </div>
</template>



<script>
import moment from "moment";
import { mapActions, mapState, mapGetters } from "vuex";
import store from "../../store";
import SimpleGoogleMap from "./../SimpleGoogleMap.vue";
import * as appConfigs from "../../configs";
import Cookies from "js-cookie";
import { generateErrorMessage } from "../../helpers";
import Datepicker from "vuejs-datepicker";
import { padStart, isEmpty, _, includes } from "lodash";
import swal from "sweetalert";
import WizardNavigation from "./../WizardNavigation";
import SummaryEndorsements from "./../SummaryEndorsements";
import OrderSummary from "./../OrderSummary";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import StripePaymentPage from "./StripePaymentPage.vue";

export default {
  props: ["paymentPageType", 'stripePk'],
  store,
  components: {
    SimpleGoogleMap,
    Datepicker,
    WizardNavigation,
    SummaryEndorsements,
    OrderSummary,
    DatePick,
    StripePaymentPage
  },
  mounted() {
    this.$store.dispatch("loadConfigs");
    // check whether all conditions were passed before coming in to this point
    this.checkPendingOrder();
  },
  data() {
    return {
      step: 5,
      showErrorMessage: false,
      fields: {
        payment_type: "",
        card_id: null, 
        card_last_four: '', 
        card_brand: '', 
        card_exp_month: "",
        card_name: "",
        card_number: "",
        card_exp_year: "",
        card_cvc: "",
        business_address_line_1: "",
        business_address_suburb: "",
        business_address_state: "",
        business_address_postcode: "",
        business_address_country: "",
        business_address_lat: "",
        business_address_lng: "",
        postal_address_line_1: "",
        postal_address_suburb: "",
        postal_address_state: "",
        postal_address_postcode: "",
        postal_address_country: "",
        postal_address_lat: "",
        postal_address_lng: "",
        abn: "",
        insurance_starts_at: null,
      },
      accepts: false,

      userConfirmedSubmission: false,
      postal_address_same_as_business_address: false,
    };
  },
  computed: {
    ...mapGetters(["isExemptFromStampDuty", "totalCostOfInsurance"]),

    disableButton() {
      // Disable button for credit card checkout
      if (this.fields.payment_type == "credit_card") {
        // Validate business address, postal address and insurance start date
        return !(
          this.isBusinessAddressProvided &&
          this.isPostalAddressProvided &&
          this.fields.insurance_starts_at
        );
      }

      // Disable button for pay in 7 days
      if (this.fields.payment_type == "bank_transfer") {
        // Validate business address, postal address, insurance start date and terms&cond
        return !(
          this.isBusinessAddressProvided &&
          this.isPostalAddressProvided &&
          this.fields.insurance_starts_at &&
          this.accepts
        );
      }

      // Disable button for Pay by Month
      if (this.fields.payment_type == "efund") {
        // Validate business address, postal address and insurance start date
        return !(
          this.isBusinessAddressProvided &&
          this.isPostalAddressProvided &&
          this.fields.insurance_starts_at
        );
      }

      if (this.fields.abn && this.fields.abn !== null) {
        // Validate abn
        var abn = this.fields.abn.replace(/ /g, "");
        return !(abn.length === 11);
      }

      return true;
    },
    canSetPostalAddressSameAsBusinessAddress() {
      // if the lat of business address is not blank, then user has already picked business address
      // return this.fields.business_address_lat != ''
      return true;
    },
    ...mapState({
      configs: (state) => state.configs,
      summaryData: (state) => state.summaryData,
      accidentCover: (state) => state.accidentCover,
      pendingOrder: (state) => state.pendingOrder,
      unavailableOccupations: (state) => state.unavailableOccupations,
      quoteRejected: (state) => state.quoteRejected,
    }),

    isUnavailableOccupation() {
      if (
        includes(this.unavailableOccupations, this.pendingOrder.occupation_id)
      ) {
        return true;
      } else {
        return false;
      }
    },

    pendingOrderId() {
      if (typeof Cookies.get("pendingOrderId") != "undefined") {
        return Cookies.get("pendingOrderId");
      }

      return false;
    },
    creditCardUrl() {
      return appConfigs.apiDomain + "images/credit-card.png";
    },
    dutyOfDisclosureUrl() {
      return appConfigs.dutyOfDisclosureUrl;
    },
    eFundInterestRate() {
      return appConfigs.eFundInterestRate;
    },
    insuranceStartsDate() {
      return this.fields.insurance_starts_at
        ? moment(this.fields.insurance_starts_at, "DD/MM/YYYY").format(
            "Do MMMM YYYY"
          )
        : null;
    },
    adjustedTotal() {
      var total = this.summaryData.totalPrice;

      if (this.accidentCover) {
        total += parseFloat(this.accidentCover.price);
      }

      return (total * this.eFundInterestRate).toFixed(2);
    },
    monthlyPayment() {
      let monthlyPayments = this.totalCostOfInsurance
        ? (this.adjustedTotal / 10).toFixed(2)
        : 0.0;
      // this.updateMonthlyPayment({ monthlyPayment  })
      return monthlyPayments;
    },
    eFundAvailable() {
      return this.summaryData.period_of_cover == 12;
    },
    isBusinessAddressProvided() {
      return !!(
        this.fields.business_address_line_1 &&
        this.fields.business_address_suburb &&
        this.fields.business_address_state &&
        this.fields.business_address_postcode
      );
    },
    isPostalAddressProvided() {
      return !!(
        this.fields.postal_address_line_1 &&
        this.fields.postal_address_suburb &&
        this.fields.postal_address_state &&
        this.fields.postal_address_postcode
      );
    },
  },
  watch: {
    "fields.payment_type"(value) {
      if (value == "credit_card") {
        this.$store.commit("setUsingCreditCard", { trueOrFalse: true });
      } else {
        this.$store.commit("setUsingCreditCard", { trueOrFalse: false });
      }
    },
    postal_address_same_as_business_address(value) {
      if (value) {
        this.copyBusinessAddressToPostalAddress();
      } else {
        this.resetPostalAddress();
      }
    },
  },
  methods: {
    ...mapActions({
      scrollToTop: "scrollToTop",
    }),
    confirmFormSubmission() {
      if (this.userConfirmedSubmission) {
        goog_report_conversion();
        this.submitForm();
        return;
      }
      if (
        this.fields.payment_type === null ||
        this.fields.payment_type === ""
      ) {
        swal("", "Please select a payment type, Thank you.", "error");
      } else {
        swal({
          icon: "info",
          title: "Are you sure?",
          text: "Once you click confirm, your order will be processed. If you chose credit card as your payment method, you will only be charged if insurance is approved and finalised, otherwise the funds will be released after 7 days.",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: "Confirm",
              value: true,
              closeModal: true,
            },
          },
        }).then((value) => {
          if (value) {
            this.userConfirmedSubmission = true;
            this.submitForm();
          }
        });
      }
    },
    disabledDates(date) {
      const dateFrom = moment(new Date()).startOf("day");
      const dateTo = moment(new Date()).startOf("day").add(30, "days");
      date = moment(date).startOf("day");
      return date < dateFrom || date > dateTo;
    },
    verifyABN() {
      var abn = this.fields.abn.replace(/ /g, "");
      if (abn.length !== 11) {
        this.$refs.abnErrorField.innerHTML =
          "<small><i class='fas fa-exclamation-circle mr-2'></i> The ABN is invalid.</small>";
      } else {
        this.$refs.abnErrorField.innerHTML = "";
        this.fields.abn = abn; // add the abn with no spaces
      }
    },
    submitForm() {
      let vm = this;
      vm.$store.commit("setScreenLoader", { showScreenLoader: true });
      axios
        .post(
          appConfigs.validateUrl,
          Object.assign(
            {},
            vm.fields,
            { step: vm.step },
            { id: vm.pendingOrderId }
          )
        )
        .then((response) => {
          vm.$store.commit("setScreenLoader", { showScreenLoader: false });
          vm.$store.commit("setEFundResponse", {
            eFundResponse: response.data.eFundResponse,
          });
          vm.$store.commit("setOrderId", { orderId: response.data.orderId });

          Cookies.remove("pendingOrderId");
          vm.$store.commit("resetState");
        })
        .catch((error) => {
          let errorMessage = generateErrorMessage(error);
          vm.$store.commit("setError", { error: errorMessage });
          vm.$store.commit("setScreenLoader", { showScreenLoader: false });
          this.userConfirmedSubmission = false;
        });
    },
    handleStripePayment(data){
      this.fields.card_last_four = data.last_four; 
      this.fields.card_id = data.payment_method_id, 
      this.fields.card_brand = data.card_brand; 
      this.submitForm(); 
    }, 
    previousClicked() {
      this.$store.commit("decrementStep");
      this.$store.commit("clearError");
      this.scrollToTop();
    },

    copyBusinessAddressToPostalAddress() {
      this.fields.postal_address_line_1 = this.fields.business_address_line_1;
      this.fields.postal_address_suburb = this.fields.business_address_suburb;
      this.fields.postal_address_state = this.fields.business_address_state;
      this.fields.postal_address_postcode =
        this.fields.business_address_postcode;
      this.fields.postal_address_country = this.fields.business_address_country;
      this.fields.postal_address_lat = this.fields.business_address_lat;
      this.fields.postal_address_lng = this.fields.business_address_lng;
    },
    resetPostalAddress() {
      this.fields.postal_address_line_1 = "";
      this.fields.postal_address_suburb = "";
      this.fields.postal_address_state = "";
      this.fields.postal_address_postcode = "";
      this.fields.postal_address_country = "";
      this.fields.postal_address_lat = "";
      this.fields.postal_address_lng = "";
    },
    bindGoogleAddressPicker(addressPrefix, event) {
      let vm = this;
      let autocomplete = new google.maps.places.Autocomplete(
        event.currentTarget,
        { types: ["geocode"], componentRestrictions: { country: "au" } }
      );
      autocomplete.addListener("place_changed", function () {
        let place = autocomplete.getPlace();
        vm.fields[addressPrefix + "_address_lat"] =
          place.geometry.location.lat();
        vm.fields[addressPrefix + "_address_lng"] =
          place.geometry.location.lng();

        vm.fields[addressPrefix + "_address_line_1"] = place.formatted_address;
        place.address_components.map(function (component) {
          if (component.types[0] == "locality") {
            vm.fields[addressPrefix + "_address_suburb"] = component.long_name;
          } else if (component.types[0] == "administrative_area_level_1") {
            vm.fields[addressPrefix + "_address_state"] = component.short_name;
          } else if (component.types[0] == "postal_code") {
            vm.fields[addressPrefix + "_address_postcode"] =
              component.short_name;
          } else if (component.types[0] == "country") {
            vm.fields[addressPrefix + "_address_country"] = component.long_name;
          }
        });
      });
    },
    formatMonthNumber(value) {
      return padStart(value, 2, 0);
    },
    checkPendingOrder() {
      if (this.pendingOrder) {
        // occupation unavailable check
        if (this.isUnavailableOccupation) {
          swal({
            icon: "error",
            title: "Online Quote Unavailable",
            text: "We need to review your answers before providing a quote binding your cover with the underwriter. Our staff will be in touch shortly.",
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                closeModal: true,
              },
              confirm: {
                text: "Ok",
                value: true,
                closeModal: true,
              },
            },
          }).then((value) => {
            window.location.reload();
          });
        }
        // check this.pendingOrder.in_referral
        if (this.pendingOrder?.in_referral) {
          swal({
            icon: "error",
            title: "Online Quote Unavailable",
            text: "We need to review your answers before providing a quote binding your cover with the underwriter. Our staff will be in touch shortly.",
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                closeModal: true,
              },
              confirm: {
                text: "Ok",
                value: true,
                closeModal: true,
              },
            },
          }).then((value) => {
            window.location.reload();
          });
        }

        // quote rejected check
        if (this.quoteRejected) {
          swal({
            icon: "warning",
            title: "Online Quote Unavailable",
            text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                closeModal: true,
              },
              confirm: {
                text: "Get A Customised Quote",
                value: true,
                closeModal: true,
              },
            },
          }).then((value) => {
            if (value) {
              window.location.href = this.configs.get_customised_quote_url;
            } else {
              window.location.reload();
            }
          });
        }
      } else {
          swal({
              icon: "warning",
              title: "Online Quote Unavailable",
              text: `Please click on the Get a Customised Quote to have one of our experts get you a customised quote.
                      We can still help you get a quote in 99% of circumstances.
                      We will just require additional information.
                      We may need to talk to a specialist insurer.`,
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: null,
                  visible: true,
                  closeModal: true,
                },
                confirm: {
                  text: "Get A Customised Quote",
                  value: true,
                  closeModal: true,
                },
              },
            }).then((value) => {
              if (value) {
                window.location.href = this.configs.get_customised_quote_url;
              } else {
                window.location.reload();
              }
            });
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../sass/form/global";
@import "../../../sass/form/sweetalert";

.pointer-cursor {
  cursor: pointer !important;
}
.bd-faded {
  background: #f3f2ee !important;
}
.up {
  width: 100% !important;
  font-weight: bold;
}
.prev {
  position: absolute !important;
  left: 0 !important;
}
.next {
  position: absolute !important;
  right: 0 !important;
}
.btn-previous {
  border-radius: 5px !important;
}
.prev,
.next {
  background: none !important;
}
.vdp-datepicker__calendar {
  background-color: #f3f2ee !important;
  border: 1px solid #e8e7e3 !important;
  border-radius: 4px !important;
  color: #66615b !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06), 0 3px 6px rgba(0, 0, 0, 0.13) !important;
}

@media screen and (max-width: 768px) {
  .sm-m-b-10 {
    margin-bottom: 10px !important;
  }
}

@media screen and (max-width: 320px) {
  .alert-simple {
    p {
      font-size: 12px;
    }
  }
}
</style>
